import { render, staticRenderFns } from "./entity-card-children-detail-siblings.vue?vue&type=template&id=5a89c392&"
import script from "./entity-card-children-detail-siblings.vue?vue&type=script&lang=js&"
export * from "./entity-card-children-detail-siblings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports